export default "https://cdn-static.gokick.com/assets/392c20f622263512bf2611e9ba1d645afacce893/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";